import { ScoreBadge, type ScoreThresholds } from "@aircall/blocks";
import { HeaderSimple } from "@/playground/components/DevHome/table/pages/conversation_center/components/HeaderSimple/HeaderSimple";
import type { RowData } from "@/playground/components/DevHome/table/pages/conversation_center/components/Table/Table.decl";
import type { ColumnType } from "../columns.decl";

// CSAT color bands: high [71,100] -> success, medium [41,71] -> warning,
// low [0,41] -> destructive-strong.
const CSAT_THRESHOLDS: ScoreThresholds = [
  { from: 71, tone: "success" },
  { from: 41, tone: "warning" },
  { from: 0, tone: "destructive-strong" },
];

function CsatDataCell({ predictedCsatScore, type }: RowData) {
  // Voicemails never get a predicted CSAT score, and a missing score renders
  // nothing rather than the "--" placeholder.
  if (type === "VOICEMAIL" || predictedCsatScore == null) {
    return null;
  }
  return (
    <ScoreBadge
      value={predictedCsatScore}
      thresholds={CSAT_THRESHOLDS}
      formatOptions={{ maximumFractionDigits: 0 }}
      className="text-sm font-semibold"
    />
  );
}

export const csatConfig: ColumnType = {
  id: "csat",
  label: <HeaderSimple label="csat" />,
  renderer: CsatDataCell,
};
